import React from 'react';
import {observer} from 'mobx-react';
import {Display, Layout, Panel} from 'components';
import {withState} from 'shared/core';
import {TaskEditState} from '../state';
import {t} from 'shared/core';
import {ModalButtons} from 'components/modals';
import {TaskTemplateFields} from 'components/tasks';

const TaskEditContainer = observer(({uiState}) => {
  const {taskTemplate, taskTemplateForm, config, errors} = uiState;

  return (
    <div>
      <Display backPath={`/tasks/${config.templateType}`}/>
      <Layout>
        <Panel>
          <Panel.Header
            title={t(`company_settings.tasks.${config.templateType}.name`)}
            description={t(`company_settings.tasks.${config.templateType}.description`)}
          />
          <TaskTemplateFields taskTemplateForm={taskTemplateForm} errors={errors}/>
          <ModalButtons
            saveCaption={`${taskTemplate.isNew ? 'Create' : 'Save'}`}
            onSave={() => uiState.saveTaskTemplate()}
            onCancel={() => uiState.goBack()}
          />
        </Panel>
      </Layout>
    </div>
  );
});

export default withState(TaskEditContainer, TaskEditState);

